<div (click)="changeDescriptionVisibility()">
  <ng-container *ngTemplateOutlet="visibleElem; context: { isDescriptionVisible: isDescriptionVisible }"></ng-container>
</div>
<div *ngIf="isDescriptionVisible" [@toggleAnim]>
  <ng-container *ngTemplateOutlet="hiddenElem"></ng-container>
</div>
